import { isCaponeTenant } from "@capone/common";
import { config } from "../../../../api/config";
import { getEarnMultiplier } from "../../../rewards/utilities";

export const getPCEarnBannerText = (earnRate: number, currency?: string) => {
  const { multiplier, currency: currencyText } = getEarnMultiplier(currency);
  return `<strong>Earn ${earnRate}${multiplier} ${currencyText}</strong> on Premier Collection purchases,
and enjoy a <strong>$100 experience credit</strong> to spend at qualifying dining, spa or
hotel activities.`;
};

export const getLCEarnBannerText = (
  hotelsMultiplier: number,
  isUserPrimary?: boolean,
  currency?: string
) => {
  const { multiplier, currency: currencyText } = getEarnMultiplier(currency);
  return isCaponeTenant(config.TENANT) || isUserPrimary
    ? `<strong>Earn ${hotelsMultiplier}${multiplier} ${currencyText}</strong> on Lifestyle Collection purchases,
  and enjoy a <strong>$50 experience credit</strong> to use toward things like signature hotel restaurants and room service.`
    : `<strong>Enjoy a <strong>$50 experience credit</strong> to use toward things like signature hotel restaurants and room service.`;
};
